import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';

import { ClientService } from 'src/app/services/client/client.service';
import { AssetService } from 'src/app/services/asset/asset.service';
import { JobService } from 'src/app/services/job/job.service';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';

import { AssetModel } from 'src/app/models/asset.model';
import { GeoObjectModel } from 'src/app/models/geoobject.model';
import { ObservationModel } from 'src/app/models/observation.model';
import { AssetFieldModel } from 'src/app/models/asset_field.model';
import { AssetPresetFieldsModel } from 'src/app/models/asset_preset_fields.model';
import { AssetTypeModel } from 'src/app/models/asset-type.model';

import { Map, tileLayer } from 'leaflet';
import L from 'leaflet';
import "leaflet.awesome-markers/dist/leaflet.awesome-markers";

import { Constants } from '../../constants/constants';


@Component({
  selector: 'modal-add-asset',
  templateUrl: './modal-add-asset.component.html',
  styleUrls: ['./modal-add-asset.component.scss'],
})
export class ModalAddAssetComponent implements OnInit {

  currentJobAssets: Array<AssetModel>;
  mapAssets: Array<AssetModel>;
  selectedAssets: Array<AssetModel>;
  selectedAsset: AssetModel = null;
  placingAsset: AssetModel = null;

  showMap = true;
  map: Map = null;

  zoomLevel: number = 19;
  maxZoomLevel: number = 21;
  minZoomLevel: number = 4;

  selectButtonText: string;

  clickedLat: number;
  clickedLon: number;

  locationGeoJson: Array<GeoObjectModel> = [];
  locationLat: number;
  locationLon: number;
  locationUid: number;
  jobUid: number;

  modalOpen = false;
 


  constructor(public appearanceService: AppearanceService, public jobService: JobService,
   public userService: UserService, public modalController: ModalController, 
   private alertController: AlertController, public clientService: ClientService,
   public assetService: AssetService) {

  }


  ngOnInit() 
  {
    this.selectedAssets = new Array<AssetModel>();
  }


  ionViewWillEnter()
  {
    this.selectedAssets = new Array<AssetModel>();
    this.selectedAsset = null;

    this.appearanceService.showLoading("Please wait...").then(() => {

      var payload = {
        clientUid: this.clientService.getClientUid(),
        organisationUid: this.clientService.getOrganisationUid(),
        locationUid: this.locationUid,
        jobUid: this.jobUid
      };

      this.jobService.getJobLocationGeo(payload).subscribe((response: any)  => {

          this.appearanceService.dismissLoading();

          if (response.Success) 
          {
            this.locationLat = response.locationLatitude;
            this.locationLon = response.locationLongitude;

            this.mapAssets = new Array<AssetModel>();

            for (var i = 0; i < response.assignableAssetTypes.length; i++)
            {
              var entry = response.assignableAssetTypes[i];

              var newAsset = new AssetModel();

              newAsset.assetType = new AssetTypeModel();
              newAsset.assetType.isStreetLight            = Boolean(JSON.parse(entry.isStreetLight));
              newAsset.assetType.assetTypeIcon            = entry.assetTypeIcon;
              newAsset.assetType.requireConditionReport   = Boolean(JSON.parse(entry.requireConditionReport));
              newAsset.assetType.assetTypeUid             = entry.assetTypeUid;
              newAsset.assetType.assetTypeName            = entry.assetTypeName;
              newAsset.assetType.allFieldValuePresets     = new Array<AssetPresetFieldsModel>();
              newAsset.fields                             = new Array<AssetFieldModel>();

              for (var x = 0; x < entry.Fields.length; x++)
              {
                var fieldEntry = entry.Fields[x];

                var newField          = new AssetFieldModel();
                newField.uid          = fieldEntry.assetFieldUid;
                newField.name         = fieldEntry.assetFieldName;
                newField.keyboardType = fieldEntry.keyboardType;
                newField.value        = null;

                newAsset.fields.push(newField);
              }

              for (var x = 0; x < entry.Presets.length; x++)
              {
                var presetEntry = entry.Presets[x];
                
                var newPreset = new AssetPresetFieldsModel();

                newPreset.uid           = presetEntry.assetPresetUid;
                newPreset.name          = presetEntry.assetPresetName;
                newPreset.defaultValues = JSON.parse(presetEntry.assetPresetValues);

                newAsset.assetType.allFieldValuePresets.push(newPreset);
              }

              this.mapAssets.push(newAsset);
            }

            if (this.mapAssets.length == 0)
            {
              this.appearanceService.presentToast("No assigned assets for this job", Constants.TOAST_INFO);
              this.modalController.dismiss(null, null, 'AddAssetModal');
              return;
            }

            this.locationGeoJson = Array<GeoObjectModel>();
  
            for (var i = 0; i < response.locationGeoJson.length; i++)
            {
              var geo = response.locationGeoJson[i];

              var newGeo = new GeoObjectModel();

              newGeo.geometry   = geo.geometry;
              newGeo.properties = geo.properties;
              newGeo.type       = geo.type;

              this.locationGeoJson.push(newGeo);
            }

            this.loadmap();
            this.showMap = true;            
          }
          else 
          {
            this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
            this.closeModal(null);
          }
        },
        err => 
        {
          this.appearanceService.dismissLoading();
          this.appearanceService.presentToast("Failed to get GeoJson.", Constants.TOAST_ERROR);
          this.closeModal(null);

        });
    });
  }


  ionViewDidEnter()
  {

  }


  ionViewWillLeave()
  {

  }


  ionViewDidLeave()
  {
    
  }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'AddAssetModal');
  }


  loadmap() 
  {
    if (!this.map)
    {
      var gps = [this.locationLat, this.locationLon];

      this.map = new Map('map', { zoomControl:false }).setView(gps, this.zoomLevel);

      this.map.touchZoom.disable();
      this.map.doubleClickZoom.disable();
      //this.map.scrollWheelZoom.disable();
      this.map.boxZoom.disable();
      this.map.keyboard.disable();
      //this.map.dragging.disable();

      var googleSatellite = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',{
        maxZoom: this.maxZoomLevel,
        subdomains:['mt0','mt1','mt2','mt3'],
        zIndex: 1
      });

      var googleHybrid = new L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{
          maxZoom: this.maxZoomLevel,
          subdomains:['mt0','mt1','mt2','mt3'],
          zIndex: 1
      });

      var openStreet = new L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{
          maxZoom: this.maxZoomLevel,
          attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          zIndex: -1
      });

      tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          // eslint-disable-next-line
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: this.maxZoomLevel,
        zIndex: -1
      }).addTo(this.map);  

      var baseLayers = {
        "Open Street": openStreet,
        "Google Hybrid": googleHybrid,
        "Google Satellite": googleSatellite
      };
  
      L.control.layers(baseLayers).addTo(this.map);

      this.map.removeLayer(openStreet);
      this.map.addLayer(googleHybrid);

      var that = this;

      this.map.on('click', function(e) 
      {
        that.clickedLat = e.latlng.lat;
        that.clickedLon = e.latlng.lng;
        that.chooseAssetTypeToPlaceOnMap();
    });
    }
    
    this.setupExistingGeoJson();
    this.map.invalidateSize();
  }


  setupExistingGeoJson()
  {
    var geo = this.locationGeoJson;

    for (var i = 0; i < geo.length; i++)
    {
      var geoObject = geo[i];

      // It's a Marker.
      if (geoObject.geometry.type == "Point")
      {
        var markerIcon = geoObject.properties.icon;
        var markerName = geoObject.properties.assetName;
        var markerDesc = geoObject.properties.description ? geoObject.properties.description : null;

        if (markerDesc)
        {
          markerName += "<br><span class='small-mrk'>" + markerDesc + "</span>";
        }

        var customIcon = this.getCustomMarkerIcon(markerIcon);
        var marker = L.marker([geoObject.geometry.coordinates[1], geoObject.geometry.coordinates[0]], { icon: customIcon }).addTo(this.map).on('click', this.markerClicked, this);

        if (markerName)
        {
          var tooltipClass = '';

          for (var x = 0; x < this.currentJobAssets.length; x++)
          {
            if (this.currentJobAssets[x].name == markerName)
            {
              tooltipClass = 'tooltip-on-job';
              break;
            }
          }
          
          var newpopup = L.tooltip({ className: tooltipClass, direction: 'top', permanent: true, offset: [-5, -30] }).setContent(markerName);
          marker.bindTooltip(newpopup).openTooltip();
          //var newpopup = L.popup({ autoClose: false }).setContent(markerName);
          //marker.bindPopup(newpopup).openPopup();
        }

        marker.properties = geoObject.properties;
      }
      // It's a Bound.
      else
      {
        /*
        var properties = geoObject.properties.assetTypeUid;

        if (!properties)
        {
          // This bound has been created on the Portal and has no properties, lets set them.
          var feature;
          var layer = geoObject;
          feature = layer.feature = layer.feature || {}; // Initialize feature

          feature.type = feature.type || "Feature"; // Initialize feature.type
          var props = feature.properties = feature.properties || {}; // Initialize feature.properties

          // Set Properties and Add Layer Again.
          layer.properties = { "markerType": Constants.GEO_TYPE_BOUND, "locationUid": this.location.locationUid, "markerUid": null };
        }

        L.geoJson(geoObject).addTo(this.map).on('click', this.polygonClicked, this);
        */
      }
    }

    if (geo.length > 0)
    {
      var geojsonLayer = L.geoJson(geo);
      var bounds = geojsonLayer.getBounds();
      this.map.fitBounds(bounds, { maxZoom: this.zoomLevel });
    }

    var that = this;

    setTimeout(() => {

      if (that.map)
      {
        that.map.invalidateSize();
      }
      
    }, 10);
  }


  async chooseAssetTypeToPlaceOnMap()
  {
    if (this.mapAssets.length == 1)
    {
      this.enterNameForNewAsset(0);
    }
    else
    {
      var theInputs = [];

      for (var i = 0; i < this.mapAssets.length; i++)
      {
        var newInput = { label: this.mapAssets[i].assetType.assetTypeName, type: 'radio', value: i };
        theInputs.push(newInput);
      }

      const alert = await this.alertController.create({
        header: 'Please select the type of asset to place',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
  
            },
          },
          {
            text: 'Ok',
            role: 'confirm',
            handler: (data) => {
              
              this.enterNameForNewAsset(data);
  
            },
          },
        ],
        inputs: theInputs,
      });

      await alert.present();
    }
  }


  async enterNameForNewAsset(chosenAssetIndex)
  {
    this.placingAsset = this.mapAssets[chosenAssetIndex];
    
    /*
    if (this.placingAsset.requireConditionReport)
    {
      this.modalOpen = true;

      const modal = await this.modalController.create({
        component: ModalAddAssetConditionComponent,
        backdropDismiss: false,
        initialBreakpoint: 0.9,
        componentProps: { isStreetLight: this.placingAsset.isStreetLight },
        cssClass: 'ninety8-screen-modal',
        id: 'NameAssetModal'
      });
  
      modal.onDidDismiss().then((response) => {
  
        this.modalOpen = false;

        if (response.data)
        {
          if (response.data.assetDetails)
          {
            // TODO
            this.placeMarker(response.data.assetDetails.assetName, null, response.data.assetDetails);
          }
        }
      })
  
      return await modal.present();
    }
    else
    {
      */
      const alert = await this.alertController.create({
        header: 'Please enter name/id for Asset',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {

            },
          },
          {
            text: 'Ok',
            role: 'confirm',
            handler: (alertData) => {
              
              if (alertData.assetName == "")
            {
              this.appearanceService.presentToast("Please enter a name.", Constants.TOAST_ERROR);
              return false;
            }

            this.placeMarker(alertData.assetName, alertData.shortDesc);

            },
          },
        ],
        inputs: [
          {
            name: 'assetName',
            placeholder: 'Name',
            attributes: {
              maxlength: 100,
            },
          },
          {
            name: 'shortDesc',
            placeholder: 'Marker Description',
            attributes: {
              maxlength: 40,
            },
          },
        ],
      });

      await alert.present();
    //}
  }


  placeMarker(assetName, shortDesc, conditionReport = null)
  {
    var gps = [this.clickedLat, this.clickedLon];

    var customIcon = this.getCustomMarkerIcon(this.placingAsset.assetType.assetTypeIcon);
    var marker = L.marker(gps, { icon: customIcon });

    if (shortDesc)
    {
      marker.properties = { 
        "assetTypeUid": this.placingAsset.assetType.assetTypeUid, 
        "icon": this.placingAsset.assetType.assetTypeIcon,
        "assetUid": null, 
        "markerUid": null, 
        "assetName": assetName,
        "description": shortDesc
      };
    }
    else
    {
      marker.properties = { 
        "assetTypeUid": this.placingAsset.assetType.assetTypeUid, 
        "icon": this.placingAsset.assetType.assetTypeIcon,
        "assetUid": null, 
        "markerUid": null, 
        "assetName": assetName
      };
    }

    marker.addTo(this.map).on('click', this.markerClicked, this);
    
    var layerId = marker._leaflet_id;
    var layer = this.map._layers[layerId];

    var shape = layer.toGeoJSON();

    if (shortDesc)
    {
      shape.properties = { 
        "assetTypeUid": this.placingAsset.assetType.assetTypeUid, 
        "icon": this.placingAsset.assetType.assetTypeIcon,
        "assetUid": null, 
        "markerUid": null, 
        "assetName": assetName,
        "description": shortDesc
      };
    }
    else
    {
      shape.properties = { 
        "assetTypeUid": this.placingAsset.assetType.assetTypeUid, 
        "icon": this.placingAsset.assetType.assetTypeIcon,
        "assetUid": null, 
        "markerUid": null, 
        "assetName": assetName 
      };
    }

    var payload = {
      geoJson: shape,
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      assetTypeUid: this.placingAsset.assetType.assetTypeUid,
      assetName: assetName,
      shortDescription: shortDesc,
      locationUid: this.locationUid,
      conditionReport: conditionReport,
      jobUid: this.jobUid
    };

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.jobService.placeNewAssetOnMap(payload).subscribe((response: any)  => {

          this.appearanceService.dismissLoading();

          if (response.Success) 
          {
            this.locationGeoJson = Array<GeoObjectModel>();
  
            for (var i = 0; i < response.GeoJson.length; i++)
            {
              var geo = response.GeoJson[i];

              var newGeo = new GeoObjectModel();

              newGeo.geometry   = geo.geometry;
              newGeo.properties = geo.properties;
              newGeo.type       = geo.type;

              this.locationGeoJson.push(newGeo);
            }

            this.removeAllLayersFromMapAndReAdd();
          }
          else 
          {
            this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
          }
        },
        err => 
        {
          this.appearanceService.dismissLoading();
          this.appearanceService.presentToast("Failed to create Asset.", Constants.TOAST_ERROR);

        });
    });
  }


  removeAllLayersFromMapAndReAdd()
  {
    var that = this;

    this.map.eachLayer(function (layer) {
      
      if (!!layer.toGeoJSON) 
      {
        var shape = layer.toGeoJSON();

        if(shape.geometry)
        {
          if (shape.geometry.type == "Point" || shape.geometry.type == "Polygon")
          {
            that.map.removeLayer(layer);
          }
        }

      }
    });

    this.setupExistingGeoJson();
  }


  markerClicked(e) 
  {
    var marker = e.target;
    
    var found = false;

    if (marker.properties)
    {
      var layerId = marker._leaflet_id;
      var markerUid = marker.properties.markerUid;
      var assetTypeUid = marker.properties.assetTypeUid;
      var assetUid = marker.properties.assetUid;
      var assetName = marker.properties.assetName;

      for (var i = 0; i < this.currentJobAssets.length; i++)
      {
        if (this.currentJobAssets[i].uid)
        {
          if (this.currentJobAssets[i].uid == assetUid)
          {
            this.appearanceService.presentToast("Asset has already been added to Job.", Constants.TOAST_INFO);
            return;
          }
        }
      }

      /*
      for (var i = 0; i < this.selectedAssets.length; i++)
      {
        if (this.selectedAssets[i].uid)
        {
          if (this.selectedAssets[i].uid == assetUid)
          {
            this.appearanceService.presentToast("Asset already selected.", Constants.TOAST_INFO);
            return;
          }
        }
      }
      */

      for (var i = 0; i < this.mapAssets.length; i++)
      {
        if (this.mapAssets[i].assetType.assetTypeUid == assetTypeUid)
        {
          this.selectedAsset = new AssetModel();

          this.selectedAsset                                  = JSON.parse(JSON.stringify(this.mapAssets[i]));
          this.selectedAsset.name                             = assetName;
          this.selectedAsset.uid                              = assetUid;
          this.selectedAsset.assetType                        = new AssetTypeModel();
          this.selectedAsset.assetType.assetTypeIcon          = this.mapAssets[i].assetType.assetTypeIcon;
          this.selectedAsset.assetType.assetTypeUid           = this.mapAssets[i].assetType.assetTypeUid;
          this.selectedAsset.assetType.assetTypeName          = this.mapAssets[i].assetType.assetTypeName;
          this.selectedAsset.assetType.requireConditionReport = this.mapAssets[i].assetType.requireConditionReport;
          this.selectedAsset.assetType.isStreetLight          = this.mapAssets[i].assetType.isStreetLight;
          
          this.selectedAsset.observations = new Array<ObservationModel>();

          if (!L.DomUtil.hasClass(marker._icon, 'markerSelected'))
          {
            L.DomUtil.addClass(marker._icon,'markerSelected');
            this.selectedAssets.push(this.selectedAsset);
          }
          else
          {
            L.DomUtil.removeClass(marker._icon,'markerSelected');

            for (var x = 0; x < this.selectedAssets.length; x++)
            {
              if (this.selectedAssets[x].uid == assetUid)
              {
                this.selectedAssets.splice(x, 1);
                break;
              }
            }
          }

          //this.selectedAssets.push(this.selectedAsset);

          if (this.selectedAssets.length == 1)
          {
            this.selectButtonText = "Add " + assetName;
          }
          else
          {
            this.selectButtonText = "Add Assets to Job";
          }
          
          found = true;
          break;
        }
      }

      if (!found)
      {
        this.appearanceService.presentToast("Asset type not assignable on this job.", Constants.TOAST_ERROR);
      }
    }
  }


  unSelectAsset(asset, index)
  {
    this.selectedAssets.splice(index, 1);
  }


  mapMarkerSelected()
  {
    // Check Selected Asset isn't already added to job.

    for (var i = 0; i < this.currentJobAssets.length; i++)
    {
      if (this.currentJobAssets[i].uid)
      {
        if (this.currentJobAssets[i].uid == this.selectedAsset.uid)
        {
          this.appearanceService.presentToast("Asset has already been added to Job.", Constants.TOAST_INFO);
          return;
        }
      }
    }

    this.addAssetToJob();
  }


  addAssetToJob()
  {
    var returnData = { assets: this.selectedAssets };
    this.modalController.dismiss(returnData, null, 'AddAssetModal');
  }
  

  getCustomMarkerIcon(icon)
  {
    return L.icon({
      iconUrl: 'assets/leaflet/marker-' + icon + '-icon.png',
      shadowUrl: 'assets/leaflet/marker-shadow.png',
      iconAnchor: [20, 31]
    });
  }
}